import {
  Card, Typography, Divider, Row, Col, Space
} from "antd";
import { useTranslation } from "react-i18next";
import Availabilities from "../../components/Availabilities";
import BlockedPeriod from "../../components/BlockedPeriod";

const { Title, Text } = Typography;

const Availability = () => {
  const { t } = useTranslation();
  return (
    <>
      <Row style={{ marginBottom: 16 }}>
        <Col span={24} md={14}>
          <Space direction="vertical" size={8}>
            <Title level={3} style={{ marginBottom: 0 }}>
              {t("availabilityPage.title")}
            </Title>
            <Text type="secondary">
              {t("availabilityPage.subtitle")}
            </Text>
          </Space>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col span={24} md={12}>
          <Card>
            <Title
              level={4}
              style={{ textAlign: "center", width: "100%", marginBottom: 0 }}
            >
              {t("availabilityPage.availability.title")}
            </Title>
            <Divider style={{ margin: "8px 0 16px" }}/>
            <Availabilities/>
          </Card>
        </Col>
        <Col span={24} md={12}>
          <Card style={{ height: "100%" }}>
            <Title
              level={4}
              style={{ textAlign: "center", width: "100%", marginBottom: 0 }}
            >
              {t("availabilityPage.blockedPeriod.title")}
            </Title>
            <Divider style={{ margin: "8px 0 16px" }}/>
            <Text type="secondary" style={{ display: "block", marginBottom: 16 }}>
              {t("availabilityPage.blockedPeriod.subtitle")}
            </Text>
            <BlockedPeriod/>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Availability;
